import React from 'react';

import Hero from '../../presentational/Hero';

function HeroContainer(props) {
  return (
    <Hero className="left" fluid link="bpeel-poster">
      <h1>1 Day<br/><em>Fresh</em> Skin</h1>
      <p>with the new <em>BPeel</em>™</p>
    </Hero>
  )
}

export default HeroContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/bpeel/HeroContainer.jsx
 **/